import CuminCompletePage from 'features/membership/components/cumin/CuminCompletePage';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import {
  GingerPagePageTemplateOptionKey,
  membershipPluginPageTemplateOptionState
} from 'features/membership/libs/recoil/selector';
import { PageTemplateOption } from 'features/membership/types';
import { FEATURES } from 'libs/features';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';

/**
 * VD+CSD カード再付番/完了
 */
const GingerCardReissueComplete: FC = () => {
  const templateOptions = useRecoilValue<
    Record<GingerPagePageTemplateOptionKey, PageTemplateOption> | undefined
  >(membershipPluginPageTemplateOptionState(TEMPLATE_ALIAS_CODE.GINGER));
  const title =
    templateOptions?.reissueCompleteTitleContentOption?.content ?? '';
  const explanation =
    templateOptions?.reissueCompleteExplanationContentOption?.content ?? '';
  const imageUrl = templateOptions?.reissueCompleteImageOption?.image_url ?? '';

  return (
    <CuminCompletePage
      title={title}
      explanation={explanation}
      imageUrl={imageUrl}
      topPagePath={`${FEATURES.membership.path}/${TEMPLATE_ALIAS_CODE.GINGER}`}
    />
  );
};

export default GingerCardReissueComplete;
